import type {ReactNode} from 'react';
import {Link} from 'react-router-dom';

import {useCurrentUser} from '../api/useCurrentUser';
import {AccessScreen} from './accessScreen';
import {Avatar} from './avatar';
import {BallotLogo} from './ballotLogo';

export const SignedIn = ({children, bare = false}: {children: ReactNode; bare?: boolean}) => {
    const {data: user, error, isLoading} = useCurrentUser();
    if (isLoading) return null;
    if (error || !user) return <AccessScreen error={error} />;
    if (bare) return <>{children}</>;
    return (
        <div className="bt-page bt-admin">
            <header className="bt-admin__top">
                <Link to="/admin" className="bt-brand">
                    <BallotLogo />
                    <span>
                        Stack<em>TheBallot</em>
                    </span>
                </Link>
                <span className="bt-admin__me">
                    {user.name}
                    <Avatar src={user.image_url ?? undefined} name={user.name} size={28} />
                </span>
            </header>
            <main className="bt-admin__main">{children}</main>
        </div>
    );
};
